















































































































































// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '@/TokenUser';
import { Auction, auctionStatus, auctionType, paymentType } from '@/Auction';
import * as utils from '../utils';
import * as utils_topshot from '../utils_topshot';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { globalUC } from '../UserCache';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import FeedbackListComponent from '@/components/FeedbackListComponent.vue';             // @ is an alias to /src
import { AuctionListing } from '@/AuctionListing';
import { Plotly } from '@rleys/vue-plotly-basic'
import { io, Socket } from "socket.io-client";
import { Feedback, roleType } from '../Feedback'
import AccountUsernameComponent from '@/components/AccountUsernameComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'AuctionComponent',
  components: { ModalWrapperComponent, Plotly, FeedbackListComponent, AccountUsernameComponent }
})
export default class AuctionComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public auctionId: string = null         // the mongod id of the auction (this is what is sent to use by the parent in their call to show)

  public moment: AuctionListing = null
  public bidPrice: string = null
  public tick: number = 1                 // hacky way to force endTime to update every second
  public feedbacksWithHeader: Feedback[] = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }
  public get collectorScoreForPosting(): number { return Auction.MIN_COLLECTOR_SCORE_TO_POST }
  public get collectorScoreForBidding(): number { return Auction.MIN_COLLECTOR_SCORE_TO_BID }
  public get bidIncrement(): number { return Auction.getBidIncrement(this.moment.auction.currentPrice) }

  public setModalTitle      // hook into the ModalWrapperComponent's setModalTitle() function

  public getPriceHeader(): string {
    if (this.moment.auction.numBids === 0) return 'Starting'
    if (this.auctionStillRunning()) return 'Current'
    if (this.moment.auction.isSuccessful()) return 'Final'
    return 'Final'
  }

  public clickToTopShot() {
    const url: string = this.moment.getTopShotLink(true)
    if (url) window.open(url, "_blank"); 
  }

  public onCancel() {
    this.$emit('close', null)
    this.clearFields()
  }

  public clearFields() {
    this.bidPrice = null
  }

  public async onShow(dynamicProps: any) {
    this.setModalTitle = dynamicProps.setModalTitle
    this.clearFields()
    this.auctionId = dynamicProps.auctionId
    await this.fetchData()
  }

  public cancelButtonText(): string {
    if (this.userIsSeller()) return 'Ok'
    return 'Close'
  }

  public bidButtonText(): string {
    if (this.moment.usersHighestBid) return 'Bid again'
    return 'Bid'
  }

  public auctionCanceled(): boolean {
    return this.moment.auction.status === auctionStatus.Canceled
  }

  public auctionFullFilled(): boolean {
    return this.moment.auction.whenFullfilled != null
  }

  public userHasBid(): boolean {
    if (!this.user) return false
    if (this.moment.usersHighestBid) return true
    return false
  }

  public userWasOutbid(): boolean {
    if (!this.user) return false
    if (!this.moment.usersHighestBid) return false
    if (this.moment.auction.highestBidder === this.user._temp.account.flowAddress) return false
    return true
  }

  public userWinningAndReserveMet(): boolean {
    if (!this.user) return false
    if (!this.moment.usersHighestBid) return false
    if (!this.moment.auction.isSuccessful()) return false
    if (this.moment.auction.highestBidder === this.user._temp.account.flowAddress) return true
    return false
  }

  public userWinningButNotMetReserve(): boolean {
    if (!this.user) return false
    if (!this.moment.usersHighestBid) return false
    if (this.moment.auction.isSuccessful()) return false
    if (this.moment.auction.highestBidder === this.user._temp.account.flowAddress) return true
    return false
  }  

  public userWinningAndReserveMetText(): string {
    if (this.auctionStillRunning()) return 'You are currently the highest bidder.'
    return 'You are the winner!'
  }

  public userWinningButNotMetReserveText(): string {
    if (this.auctionStillRunning()) return "You are currently the highest bidder but the reserve price hasn't been met."
    return 'You were the highest bidder but the reserve price was not met.'
  }

  public getPaymentMethodsString(): string {
    const paymentMethods: paymentType[] = this.moment.auction.paymentTypes
    if (!paymentMethods) return 'None specified'
    let niceString: string = paymentMethods.map((pt) => Auction.getPaymentTypeString(pt)).join(' or ')
    for (let i = 0; i < paymentMethods.length - 2; i++ ) niceString = niceString.replace(' or ', ', ')
    return niceString
  }

  public showFAQ() {
    (this.$refs.FAQAuctionsComponent as ModalWrapperComponent).show('Auctions FAQ', 'lg', null)
  }

  public showBidConfirmation() {
    const dynamicProps: any = {}
    dynamicProps.confirmationText = 
      `By clicking <span class="highlight">I Agree</span>, you confirm that if you win, you agree to coordinate by email with the seller to pay via <span class="highlight">${ this.getPaymentMethodsString() }</span>, and to receive the moment via Top Shot's <span class="highlight">gifting</span> mechanism after payment.<br /><br />You cannot use Dapper credit to make payment.`
    dynamicProps.positiveButtonName = 'I Agree';
    (this.$refs.BidConfirmationComponent as ModalWrapperComponent).show('Confirm Bid', 'sm', dynamicProps)
  }

  public showCancelConfirmation() {
    const dynamicProps: any = {}
    dynamicProps.confirmationText = 
      `Are you sure you want to cancel this auction?`
    dynamicProps.positiveButtonName = 'Yes';
    dynamicProps.negativeButtonName = 'No';
    (this.$refs.CancelConfirmationComponent as ModalWrapperComponent).show('Cancel Auction', 'sm', dynamicProps)
  }

  public userAgreedOrCanceledBid(componentName: string, showing: boolean, payload: any) {
    if (showing) return
    const agreed: boolean = payload as boolean
    if (agreed) this.onSubmitBid()
  }

  public userAgreedOrCanceledTheCancel(componentName: string, showing: boolean, payload: any) {
    if (showing) return
    const agreed: boolean = payload as boolean
    if (agreed) this.onCancelAuction()
  }

  public collectorScoreRequirementsMet(): boolean {
    if (!this.user) return false
    // if (this.user.email === 'bonfire@livetoken.co') return true
    return this.user._temp.account && this.user._temp.account.collectorScore2 && this.user._temp.account.collectorScore2b.total >= Auction.MIN_COLLECTOR_SCORE_TO_BID
  }

  public whyButtonDisabled(): string {
    if (!utils_topshot.getHasReadAuctionFAQ()) return 'Please read the FAQ before bidding for the first time'
    if (!this.bidPrice && !Number(this.bidPrice)) return ''
    if (this.userIsSeller()) return 'You cannot bid on your own auction.'
    if (!this.user) return 'You must have a registered LiveToken account to bid on auctions.'
    if (!this.user.emailVerified) return 'You need to verify your email address to bid on auctions.'
    if (!this.user.topShotVerified || !this.user.linkedAccountId) return 'You need to link your Top Shot Account to bid on auctions.'
    if (!this.collectorScoreRequirementsMet()) return `You must have a Top Shot Score of at least ${Auction.MIN_COLLECTOR_SCORE_TO_BID} to bid on auctions.`
    return null
  }

  public auctionStillRunning(): boolean {
    if (!this.moment) return false
    if (this.moment.auction.status !== auctionStatus.Open) return false
    return true
  }

  public userIsSeller(): boolean {
    if (!this.user) return false
    if (this.moment.sellerAddress === this.user.linkedFlowAddress) return true
  }

  public userIsHighBidder(): boolean {
    if (!this.user) return false
    return this.moment.userIsHighestBidder(this.user)
  }  

  public showActionsArea(): boolean {
    if (this.userIsSeller() && this.moment.auction.isCancelable()) return true
    if (this.userIsSeller() && this.moment.auction.isFeedbackLeavable(roleType.Seller) && !this.moment.auction.alreadyHasFeedback(roleType.Seller)) return true
    if (this.userIsHighBidder() && this.moment.auction.isFeedbackLeavable(roleType.Buyer) && !this.moment.auction.alreadyHasFeedback(roleType.Buyer)) return true
    return false
  }

  public getNiceCollectorScore(score: number) {
    return utils_topshot.getNiceCollectorScore(score)
  }
  public getNiceAuctionScore(score: number) {
    return utils_topshot.getNiceAuctionScore(score)
  }

  public getClassNameBasedOnScore(score: number) {
    return utils_topshot.getClassNameBasedOnScore(score)
  }
  public getClassNameBasedOnAuctionScore(score: number) {
    return utils_topshot.getClassNameBasedOnAuctionScore(score)
  }

  public getEndedBoxClassName(): string {
    if (this.auctionCanceled()) return "negative"
    if (!this.moment.auction.endedSuccessfully) return "negative"
    if (this.auctionFullFilled()) return "positive"
    if (!this.auctionFullFilled()) return "yellow"
  }


  public onPostFeedback() {
    let ratee: string = this.moment.sellerAddress;
    let rateeUsername: string = this.moment.sellerUsername;
    let rateeRole: roleType = roleType.Seller
    if (utils_topshot.sansPrefix(this.user._temp.account.flowAddress) === utils_topshot.sansPrefix(ratee)) {
      ratee = this.moment.winningAddress
      rateeUsername = this.moment.winningUsername
      rateeRole = roleType.Buyer
    }
    const dynamicProps: any = { auctionId: this.auctionId, ratee, rateeUsername, rateeRole };
    (this.$refs.FeedbackFormComponent as ModalWrapperComponent).show('Post Feedback About ' + rateeUsername, 'sm', dynamicProps)
  }

  public async onFeedbackFormClosed(componentName: string, showing: boolean, payload: any) {
    if (showing) return
    if (payload) {
      // existence of payload means the user successfully left a feedback
      const feedback: Feedback = payload
      await this.fetchData()            // refetch so that feedback will show up
    }
  }

  public async onCancelAuction() {
    if (!this.moment.auction.isCancelable()) {
      utils.toast(this, 'Error', 'This auction is not cancelable')
      return
    }

    // make POST or PUT call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/topshot/auction/cancel/' + this.moment.auction.getIdAsString();
      const putData: any = {} 
      const response: any = await utils.makePutCall(url, putData)
      if (!response || !response.data) throw(new Error('AuctionComponent.onOK() got null response or null response.data'))

      // something is wrong with the bid
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)

        // should refresh the auction since maybe the auction has updated? Or does socket.io take care of it already? socket.io should be sufficient
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      // success
      if (response.data.moment) {
        this.moment = new AuctionListing(response.data.moment)
        if (this.moment.auction.status === auctionStatus.Canceled) utils.toast(this, 'Canceled', `The auction was canceled successfully.`);
        else utils.toast(this, 'Error', `The auction could not be canceled.`);
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Auction cancelation failed')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

 

  public async onSubmitBid() {
    // validate form fields
    let abort: boolean = false

    // fields
    const bidPrice: number = Number(this.bidPrice)
    if (isNaN(bidPrice)) { abort = true; utils.toast(this, 'Invalid field', 'Bid price') }

    if (!this.user) { abort = true; utils.toast(this, 'Error', 'You must be logged in to bid') }

    if (abort) return

    // make POST or PUT call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/topshot/auction/bid';
      const postData: any = { auctionId: this.moment.auction.getIdAsString(), bidAmount: this.bidPrice } 
      const response: any = await utils.makePostCall(url, postData)
      if (!response || !response.data) throw(new Error('AuctionComponent.onOK() got null response or null response.data'))

      // something is wrong with the bid
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)

        // should refresh the auction since maybe the auction has updated? Or does socket.io take care of it already? socket.io should be sufficient
      }
      
      // might as well update the user
      if (response.data.user) {
        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
      }

      // success
      if (response.data.moment) {
        this.moment = new AuctionListing(response.data.moment)
        if (this.moment.auction.highestBidder === this.user.linkedFlowAddress) {
          utils.toast(this, 'Success', `You are winning at $${this.moment.auction.currentPrice.toFixed(2)}`, 4500);
          if (this.moment.usersHighestBid > this.moment.auction.currentPrice) utils.toast(this, 'Auto Bidding', `We'll automatically bid on your behalf up to $${this.moment.usersHighestBid.toFixed(2)} if necessary.`, 6500);
        } else {
          utils.toast(this, 'Outbid', `Your bid was accepted but you were immediately outbid.`);
        }
        utils_tracker.track(`Bid Submitted`, { momentID: this.moment.momentID, user: this.user.getIdAsString() })
        this.clearFields()
        if (this.moment.auction.didAutoExendOnLastBid) utils.toast(this, 'Auto Extension', `The auction was extended to 1 min.`, 8500);
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Bid failed')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables
  private timer
  private socket: Socket = null
  private numConnectionErrors: number = 0
  private isConnectedBySocket: boolean

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    this.timer = setInterval(function() {
      this.tick++
    }.bind(this), 1000)

  }
  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)

    if (this.timer) clearTimeout(this.timer)
    this.timer = null

    if (this.socket && this.isConnectedBySocket) {
      this.socket.emit('leaveRoom', `auction/${this.moment.auction.getIdAsString()}`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
      this.socket.disconnect()
    }
    this.socket = null

  }


  private async fetchData(): Promise<boolean> {
    this.$store.commit('setLoading', { loading: true });
    try {
      const url: string = utils.getURLprefix() + `/api/topshot/auction/${this.auctionId}`
      if (this.$store.state.devmode) console.log(`Calling ${url}`);
      const response: any = await utils.makeGetCall(url);

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        this.onCancel()
        return false
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        this.onCancel()
        return false
      }

      // update the moment (AuctionListing)
      if (response.data.moment) {
        this.moment = new AuctionListing(response.data.moment)
        this.setModalTitle(`${this.moment.name}${this.moment.auction.type === auctionType.Flash ? ' (Flash Auction)' : ''}`)   // TODO: decide what to set for modalTitle - maybe time left countdown?

        // TODO: fill in feedbacksWithHeader


        this.connectSocket()
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      this.$store.commit("setLoading", { loading: false });
      this.onCancel()
      return false
    }
    this.$store.commit("setLoading", { loading: false });
    return true
  }

  // https://socket.io/docs/v4/client-socket-instance/
  private connectSocket() {
    if (this.socket && this.isConnectedBySocket) return
    try {
      // https://socket.io/docs/v3/using-multiple-nodes/
      this.socket = io(utils.getURLprefix(), { autoConnect: true, transports: [ "websocket" ] });   // it was very important to not allow polling 

      // for debugging
      if (this.$store.state.devmode) {
        this.socket.onAny((event, ...args) => {
          console.log(event, args);
        });
      }

      // handle an updated AuctionListing being sent in from server (but sans usersHighestBid, so let's preserve the one we had)
      this.socket.on("auctionListing", (po: object) => {
        const updatedMoment: AuctionListing = new AuctionListing(po)
        if (this.moment && updatedMoment.momentID === this.moment.momentID) {
          const usersHighestBid: number = this.moment.usersHighestBid
          this.moment = updatedMoment
          this.moment.usersHighestBid = usersHighestBid
          if (this.$store.state.devmode) console.log(`Got updated auctionListing moment for ${updatedMoment.auction.getIdAsString()}`);
        } else {
          if (this.$store.state.devmode) console.log(`Got updated auctionListing moment for ${updatedMoment.auction.getIdAsString()} for was the wrong momentID (user probably switched auctions in same tab)`);
        }
      });

      // This event is fired by the Socket instance upon connection and reconnection
      this.socket.on("connect", async () => {
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} connected`)
        if (this.socket) {
          this.isConnectedBySocket = true
          this.socket.emit('joinAuctionRoom', `auction/${this.moment.auction.getIdAsString()}`, this.user && this.user._temp.account ? this.user._temp.account.username : null, this.userId ? this.userId : null )
        }
      });
      this.socket.on("connect_error", async () => {
        this.numConnectionErrors++
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} got connect_error. Waiting ${this.numConnectionErrors}s before attempting reconnect`)
        await utils.sleep(this.numConnectionErrors * 1000)
        this.isConnectedBySocket = false
        if (this.socket) this.socket.connect();
      });
      this.socket.on("disconnect", (reason: string) => {
        this.isConnectedBySocket = false

        // not sure why every so often we get - "Socket undefined disconnected with reason: transport close"
        if (this.$store.state.devmode) console.log(`${new Date().toLocaleString()}: Socket ${this.socket.id} disconnected with reason: ${reason}`)

        if (reason === "io server disconnect") {
          // the disconnection was initiated by the server, so you need to reconnect manually (other forms of disconnect will auto reconnect)
          // if (this.$store.state.devmode || utils_topshot.getBubbaMode()) console.log(`${new Date().toLocaleString()}: Atempting manual reconnect because reason was ${reason}`)
          if (this.socket) this.socket.connect();
        }

      });

    } catch (e) {

    }

  }

}
